import { CmsModel } from 'client/data/models/cms';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { pageDefinition } from 'client/site-modules/shared/pages/page';
import { parseContent } from 'client/data/cms/content';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { CALCULATORS_BREADCRUMBS } from 'client/site-modules/calculators/constants/calculators';
import { Calculators, CALCULATORS_CONTENT_FILE_PATH } from './calculators';

export const pageDefinitionConfiguration = {
  name: 'calculators',
  category: 'calculators',
  component: Calculators,
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(`content["${CALCULATORS_CONTENT_FILE_PATH}"]`, CmsModel);
    return preloader.load();
  },
  seo: state => {
    const modelState = getModelState(state);
    const content = modelState.get(`content["${CALCULATORS_CONTENT_FILE_PATH}"]`, CmsModel);
    const parsedContent = parseContent(content);
    const meta = getMeta(parsedContent);

    return {
      ...meta,
      jsonld: [getBreadcrumbSchema(CALCULATORS_BREADCRUMBS)],
    };
  },
};

export default pageDefinition(pageDefinitionConfiguration);
